import React, { useEffect } from "react";
import "./TestimonialNew.css";
import profile1 from "../../../Assets/newAsset/TestiProfile.webp";
// import testimonialProfile from "../../../Assets/newAsset/testimonialProfile.jpeg";ss

import { useDispatch, useSelector } from "react-redux";
import { GET_TESTIMONIALS_REQUEST } from "../../../Redux/Constants";
import { testimonials, blogs } from "../../../Redux/Actions";
import Loader from "../../../components/Loader/Loader";
//importing CARASOUL
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { AiTwotoneStar } from "react-icons/ai";

//RESPONSIVE SCRREEN
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1500 },
    items: 3,
  },
  smallDesktop: {
    breakpoint: { max: 1500, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 480 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 480, min: 0 },
    items: 1,
  },
};

function TestimonialNew() {
  const testimonalsdata = useSelector((state) => state.testimonials);
  const testimonialdata = testimonalsdata.testimonials;
  const { loading } = testimonalsdata;
  // console.log("testi data", testimonialdata);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(testimonials());
  }, []);

  return (
    <React.Fragment>
      {/**USE THIS COMMENTED CODE FOR API TESTIMONIAL DATA */}
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="divHeading divHeadingTesti hideGoogle">
            <img width="100" height="auto" src={"https://staticcdn.redcliffelabs.com/media/gallary-file/None/4c598d17-aba3-4176-be09-4f969d445e83.png"} alt="google logo" />
            <h2>Reviews</h2>
            <div className="googleStats">
                  <AiTwotoneStar />
                  <span>4.7(7620+ Ratings)</span>
                </div>
          </div>
           {/* MOBILE VIEW FOR THE TESTIMONIAL */}
           <div className="divHeadingMob divHeadingTestiMob ">
              <div className="upperReview">
               <img width="100" height="auto" src={"https://staticcdn.redcliffelabs.com/media/gallary-file/None/4c598d17-aba3-4176-be09-4f969d445e83.png"} alt="google logo" />
               <h2>Reviews</h2>
              </div>
              <div className="googleStatsMob">
                  <AiTwotoneStar />
                  <span>4.7 (7620+ Ratings)</span>
                </div>
            </div>

          <Carousel
            swipeable={true}
            draggable={false}
            showDots={false}
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={2500}
            transitionDuration={200}
            deviceType={"tablet"}
          >
            {testimonialdata &&
              testimonialdata.results &&
              testimonialdata.results.map((value) => {
                return (
                  <div
                    className="Package__card Package__cardNeww Package__cardNewTesi bgOrdinary testiPackageHeight"
                    // className="testOuter"
                    key={value.id}
                  >
                    <div className="testimonial__card">
                      <div className="testimonial__cardHeader">
                        <LazyLoadImage
                          src={value.image}
                          alt="Profile logo"
                          delayTime="100"
                        />
                        <div className="card__headerUserDetails">
                          <span>
                            {value.title ? (
                              <span>{value.author_name}</span>
                            ) : (
                              <span>nothing</span>
                            )}
                          </span>
                          <span>
                            {value.address ? (
                              <span>{value.address}</span>
                            ) : (
                              <span> </span>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="testimonial__cardTitle">
                        <span>"{value.title}"</span>
                      </div>
                      <div className="testimonial__cardFooter">
                        <span></span>
                        <span>
                          <div>
                            {value.description.length > 250
                              ? `${value.description.substring(0, 250)}...`
                              : value.description}
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
          </Carousel>
        </>
      )}

      {/**USE THIS COMMENTED CODE FOR STATIC TESTIMONIAL DATA */}
      {/* {TestimonialData.map((values) => {
        return <TestimonialCard value={values} key={values.id} />;
      })} */}
    </React.Fragment>
  );
}

export default TestimonialNew;
